import type { ScenePoint } from "./MapScene";

// Позиция на пути в момент `t` (секунды): между точками — линейно. Мёртв — `null`;
// данных в этот момент нет — последняя известная точка.
export const pointAt = (
  track: readonly (ScenePoint | null)[],
  stepS: number,
  t: number,
): ScenePoint | null => {
  if (track.length === 0) {
    return null;
  }
  const f = Math.max(0, Math.min(track.length - 1, t / stepS));
  const i = Math.floor(f);
  const a = track[i] ?? null;
  const b = track[Math.min(track.length - 1, i + 1)] ?? null;
  if (a !== null && b !== null) {
    const k = f - i;
    return [a[0] + (b[0] - a[0]) * k, a[1] + (b[1] - a[1]) * k, k < 0.5 ? a[2] : b[2]];
  }
  return a;
};
